import { render, staticRenderFns } from "./ChannelCurvesChartMultiInstance.vue?vue&type=template&id=69060f17&"
import script from "./ChannelCurvesChartMultiInstance.vue?vue&type=script&lang=js&"
export * from "./ChannelCurvesChartMultiInstance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports